import KeenSlider from "keen-slider";
import event from "../lib/mixins/event";

class CuratedSocialFeed {
	constructor(dom) {
		this.NAME = "CuratedSocialFeed";
		this.dom = dom;
		this.slider = null;
	}

	init() {
		const track = this.dom.querySelector("[data-csf-track]");
		const prevBtn = this.dom.querySelector("[data-csf-prev]");
		const nextBtn = this.dom.querySelector("[data-csf-next]");

		if (!track) return;

		this.slider = new KeenSlider(track, {
			loop: true,
			slides: { perView: 1.9, spacing: 24, origin: "center" },
			breakpoints: {
				"(min-width: 640px)": {
					slides: { perView: "auto", spacing: 24, origin: "center" },
				},
				"(min-width: 1024px)": {
					slides: { perView: "auto", spacing: 24, origin: "center" },
				},
			},
		});

		if (prevBtn) prevBtn.addEventListener("click", () => this.slider?.prev());
		if (nextBtn) nextBtn.addEventListener("click", () => this.slider?.next());
	}
}

Object.assign(CuratedSocialFeed.prototype, event);
export default CuratedSocialFeed;
